export default {
  EVENTS: 'Events',
  ADMISSION_GROUPS: 'Admission Groups',
  CUSTOMERS: 'Customers',
  STAFF_MEMBERS: 'Staff Members',
  PROMOTERS: 'Promoters',
  BILLING: 'Billing'
};



// WEBPACK FOOTER //
// ./src/constants/trackingEventCategories.js